<template>
  <div id="app">

    <header>
      <app-header></app-header>
    </header>

    <main>
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </main>
    <footer class="footer is-dark">
      <app-footer></app-footer>
    </footer>

<div class="modal" :class="!cookie && $route.name!='impressum' ? 'is-active' : ''">
  <div class="modal-background"></div>
    <div class="modal-card">
    <section v-if="!cookieSettings" class="modal-card-body" style="border-radius:6px;margin:0 15px !important;">
      <p style="margin-bottom:20px;">Für ein optimales Benutzerlebnis empfehlen wir die Aktivierung von Cookies. Erfahren Sie mehr über Cookies und Datenschutz in unserer  <router-link to="/impressum">Datenschutzerklärung</router-link>.</p>
      <button class="button is-warning is-medium is-fullwidth" style="margin-bottom:10px;" @click="$store.commit('setCookies', {maps: true,videos: true,ga: true})">Alle Cookies akzeptieren</button>
      <button class="button is-warning is-medium is-fullwidth" @click="showSettings">Cookie Einstellungen</button>
    </section>
    <section v-else class="modal-card-body" style="border-radius:6px;margin:0 15px !important;">
      <button class="button is-text" style="text-decoration:none;margin-bottom:10px;" @click="cookieSettings=false"> <span class="icon is-small">
      <i class="fas fa-chevron-left"></i>
    </span><span>Zurück</span></button>
      <p style="margin-bottom:20px;">Konfigurieren Sie Ihre Cookie- und Datenschutzeinstellungen</p>
      <div class="field">
  <input id="maps" type="checkbox" name="switchExample" class="switch" v-model="cookiePrefs.maps">
  <label for="maps">Karten mit Google Maps</label>
</div>
      <div class="field">
  <input id="videos" type="checkbox" name="switchExample" class="switch" v-model="cookiePrefs.videos">
  <label for="videos">Videos mit Youtube</label>
</div>
      <div class="field" style="margin-bottom:30px;">
  <input id="ga" type="checkbox" name="switchExample" class="switch" v-model="cookiePrefs.ga">
  <label for="ga">Google Analytics</label>
</div>
      <button class="button is-medium is-warning is-fullwidth" style="margin-bottom:10px;" @click="saveSettings">Speichern</button>
      <button class="button is-medium is-fullwidth" @click="cookieSettings=false">Zurück</button>
    </section>

  </div>
</div>



  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
    data() {
    return {
      cookieSettings: false,
      cookiePrefs: {
        maps: true,
        videos: true,
        ga: true
      }
    }
    },
  components: {
    appHeader: Header,
    appFooter: Footer
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Thayatal',
    // all titles will be injected into this template
    titleTemplate: '%s - Urlaub im Waldviertel'
  },
  methods: {
    saveSettings() {
      this.$store.commit('setCookies', this.cookiePrefs)
      this.cookieSettings = false
    },
    showSettings() {
      if (this.cookies_maps) {
        this.cookiePrefs.maps = true
      } else {
        this.cookiePrefs.maps = false
      }
      if (this.cookies_yt) {
        this.cookiePrefs.videos = true
      } else {
        this.cookiePrefs.videos = false
      }
      if (this.cookies_ga) {
        this.cookiePrefs.ga = true
      } else {
        this.cookiePrefs.ga = false
      }
      this.cookieSettings = true
    }
  },
  computed: {
    filterContent () {
      return this.$store.getters.filterContent
    },
    location () {
      return this.$store.getters.location
    },
    cookie () {
      return this.$store.getters.cookie
    },
    cookies_maps() {
      return this.$store.getters.cookies_maps
    },
    cookies_yt() {
  return this.$store.getters.cookies_yt
    },
    cookies_ga() {
      return this.$store.getters.cookies_ga
    },
  },
  created () {
    // this.$store.dispatch('tryAutoLogin')
    this.$store.dispatch('fetchContentFrontend')
    if (this.location) {
      this.$store.dispatch('getLocation')
    }
    // Detects if device is on iOS
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase()
      return /iphone|ipad|ipod/.test(userAgent)
    }
    // Detects if device is in standalone mode
    const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone)
    // Checks if should display install popup notification
    // Dont show in iOS Chrome, Firefox, Opera and Edge
    if (isIos() && !isInStandaloneMode() && (window.navigator.userAgent.indexOf('CriOS') === -1) && (window.navigator.userAgent.indexOf('FxiOS') === -1) && (window.navigator.userAgent.indexOf('Opera Mini') === -1) && (window.navigator.userAgent.indexOf('EdgiOS') === -1)) {
      this.$store.dispatch('isiOS')
    }
    // show iOS installation dialog every 14 days
    // check if date was set already in the past
    const installiOSDialogShown = localStorage.getItem('installiOSDialogShown')
    if (!installiOSDialogShown) {
      // first time visit, set date
      localStorage.setItem('installiOSDialogShown', new Date())
      this.$store.commit('showInstallDialog', true)
    } else {
      const now = new Date()
      const dateDiff = now - new Date(installiOSDialogShown)
      if (dateDiff > 1209600000) {
        // second time visit, if it was longer than 2 weeks ago show dialog again
        this.$store.commit('showInstallDialog', true)
        // and update date to now
        localStorage.setItem('installiOSDialogShown', new Date())
      } else {
        // visit within last 14 days, dont show dialog
        this.$store.commit('showInstallDialog', false)
      }
    }
    const vm = this
    setTimeout(function() {
      vm.$store.commit('autoActivateGA')
    }, 2000)
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s ease;
}
.fade-enter, .fade-leave-active {
  opacity: 0
}
.child-view {
  position: absolute;
  transition: all .1s cubic-bezier(.55,0,.1,1);
}
.slide-left-enter, .slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active, .slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
</style>
